import * as React from 'react';
import { Link } from 'react-router';
import { SearchBoxContainer } from '../../common/components/searchBox/searchBoxContainer';
import { TopNavigationContainer } from '../../common/components/topNavigation/topNavigationContainer';

import logo from '../../img/logo.png' // relative path to image 

export const Header: React.StatelessComponent<{}> = () => {
  return (
<header id="header">
<div className="container">
    <Link to="/" className="logo"><img src={logo} /></Link>
    <SearchBoxContainer />
  </div>
  <TopNavigationContainer/>
</header>
  );
}


// WEBPACK FOOTER //
// ./src/components/shared/header.tsx